<div class="cf-dlg sp-dlg">
    <div class="cf-dlg-header">
        <div class="cf-dlg-icon"><mat-icon>support_agent</mat-icon></div>
        <div class="sp-dlg-heading">
            <h2 class="cf-dlg-title">Nueva incidencia</h2>
            <p class="cf-dlg-subtitle">Cuéntanos qué ocurre y el equipo de Handly te responderá aquí</p>
        </div>
        <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" [disabled]="saving" aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <ng-container *ngIf="!saving; else savingTpl">
        <form [formGroup]="ticketForm" (ngSubmit)="save()" novalidate>
            <div class="cf-dlg-body">
                <span class="sp-field-label">Prioridad</span>
                <div class="sp-priority-picker" role="radiogroup" aria-label="Prioridad">
                    <button type="button" role="radio" *ngFor="let p of priorities"
                        class="sp-priority-option" [ngClass]="'sp-priority-option--' + p.className"
                        [class.sp-priority-option--active]="ticketForm.get('Priority').value === p.value"
                        [attr.aria-checked]="ticketForm.get('Priority').value === p.value"
                        (click)="setPriority(p.value)">
                        <span class="sp-priority-option__dot"></span>{{ p.label }}
                    </button>
                </div>

                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Módulo</mat-label>
                    <mat-select formControlName="Category" placeholder="¿Dónde ocurre?">
                        <mat-option *ngFor="let c of categories" [value]="c">{{ c }}</mat-option>
                    </mat-select>
                    <mat-error>Selecciona el módulo.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Asunto</mat-label>
                    <input matInput formControlName="Subject" placeholder="Resumen breve del problema" maxlength="150" />
                    <mat-error>Indica el asunto.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Mensaje</mat-label>
                    <textarea matInput formControlName="Message" rows="6"
                        placeholder="Describe qué estabas haciendo, qué esperabas y qué ha pasado"></textarea>
                    <mat-error>Escribe el mensaje.</mat-error>
                </mat-form-field>
            </div>

            <div class="cf-dlg-footer">
                <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cancelar</button>
                <button type="submit" mat-flat-button class="cf-dlg-btn-primary">
                    <mat-icon>send</mat-icon> Enviar incidencia
                </button>
            </div>
        </form>
    </ng-container>

    <ng-template #savingTpl>
        <app-loading-state message="Enviando incidencia…"></app-loading-state>
    </ng-template>
</div>
